import { Icon, SliderModal, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Pressable, Skeleton } from 'native-base';
import React from 'react';
import { StyleSheet } from 'react-native';

import { ManagementFeeStatus } from '../../../store/rateManagement/constants';

import { Card } from './components/Card';
import { FooterTable } from './components/FooterTable';
import { HeaderSection } from './components/HeaderSection';
import { TableCustomerDetail } from './components/TableCustomerDetail/table';

import { RequestDetailsTypes } from '.';

export const RequestDetailsDesktop: React.FC<RequestDetailsTypes.Props> = ({
  onCloseDetails,
  onCancelOrder,
  onSendOrder,
  onSelectTable,
  onExport,
  sentOrder,
  error,
  loading,
  isNeedingAttentionEmpty,
  isValidCustomersEmpty,
  tableSelected,
}) => {
  return (
    <SliderModal onDismiss={onCloseDetails}>
      <VStack padding={Spacing['stack.xxs']} style={styles.view} flex={1}>
        <HeaderSection
          onDownloadFile={onExport}
          canDownloadFile={sentOrder?.canDownloadFile}
          sendId={sentOrder?.managementFeeHashNormalized}
          status={sentOrder?.managementFeeStatusTextNormalized}
          iconName={sentOrder?.managementFeeStatusIconNormalized}
          iconColor={sentOrder?.managementFeeStatusIconColorNormalized}
          iconSize={sentOrder?.managementFeeStatusIconSizeNormalized}
          iconBackgroundColor={sentOrder?.managementFeeStatusIconBackgroundNormalized}
          lastUpdate={sentOrder?.lastUpdateNormalized}
          onCloseDetails={onCloseDetails}
          loading={loading}
        />

        {sentOrder?.managementFeeStatusNormalized === ManagementFeeStatus.Scheduled && (
          <HStack
            testID={'warning-container'}
            backgroundColor={Color['feedback.attention.lightest']}
            borderRadius={'8px'}
            mb="20px"
            space="6px"
            alignItems={'center'}
            p={'8px'}>
            <Icon
              testId={'warning-icon'}
              name={'Warning'}
              size="xxs"
              color={Color['feedback.attention.default']}
            />
            <Text
              isLoading={loading}
              color={'neutral.black'}
              fontSize={Typography['fontsize.xs']}
              variant="regular">
              <Text isLoading={loading} fontWeight={Typography['fontweight.semibold']}>
                Atenção:
              </Text>{' '}
              Antes do envio, faremos outro processamento. É possível que ocorram divergências na
              solicitação
            </Text>
          </HStack>
        )}

        {loading ? (
          <Skeleton
            marginBottom={Spacing['inline.nano']}
            testID="test-skeleton"
            borderRadius={'sm'}
            height={'14px'}
          />
        ) : (
          <Text
            paddingBottom={Spacing['inline.nano']}
            fontWeight={Typography['fontweight.semibold']}
            fontSize={Typography['fontsize.md']}
            color="brand.primary.darkest">
            Detalhes da solicitação
          </Text>
        )}

        <Card sentOrderDetail={sentOrder} loading={loading} />
        <HStack paddingBottom={Spacing['inline.nano']}>
          {!isValidCustomersEmpty && (
            <Pressable onPress={() => onSelectTable('valid')} marginRight={Spacing['inline.xs']}>
              <Text
                isLoading={loading}
                mb={Spacing['inline.nano']}
                variant={tableSelected === 'valid' ? 'semibold' : 'regular'}
                fontSize={Typography['fontsize.md']}
                color={tableSelected === 'valid' ? 'brand.primary.darkest' : 'neutral.darkest'}>
                Clientes validados ({sentOrder?.validCustomerTotal})
              </Text>
              {tableSelected === 'valid' && (
                <Box borderBottomColor="brand.primary.darkest" borderBottomWidth="2" width="10%" />
              )}
            </Pressable>
          )}

          {!isNeedingAttentionEmpty && (
            <Pressable onPress={() => onSelectTable('requiresAttention')}>
              <Text
                isLoading={loading}
                mb={Spacing['inline.nano']}
                variant={tableSelected === 'requiresAttention' ? 'semibold' : 'regular'}
                fontSize={Typography['fontsize.md']}
                color={
                  tableSelected === 'requiresAttention'
                    ? 'brand.primary.darkest'
                    : 'neutral.darkest'
                }>
                Clientes inválidos ({sentOrder?.invalidCustomerTotal})
              </Text>
              {tableSelected === 'requiresAttention' && (
                <Box borderBottomColor="brand.primary.darkest" borderBottomWidth="2" width="10%" />
              )}
            </Pressable>
          )}
        </HStack>

        {tableSelected === 'requiresAttention' && (
          <>
            {loading ? (
              <Skeleton
                marginBottom={Spacing['inline.nano']}
                testID="test-skeleton"
                borderRadius="sm"
                height="30px"
              />
            ) : (
              <HStack
                testID="warning-container"
                backgroundColor="rgba(254, 225, 178, 0.4)"
                borderRadius="8px"
                mt={Spacing['inline.nano']}
                mb={Spacing['inline.xxxs']}
                space="6px"
                alignItems="center"
                p="8px">
                <Icon
                  testId="warning-icon"
                  name="Warning"
                  size="xxs"
                  color={Color['feedback.attention.default']}
                />
                <Text
                  isLoading={loading}
                  color="neutral.black"
                  fontSize={Typography['fontsize.xs']}
                  variant="regular">
                  <Text isLoading={loading} fontWeight={Typography['fontweight.semibold']}>
                    Atenção:
                  </Text>{' '}
                  Clientes inválidos não serão enviados.
                </Text>
              </HStack>
            )}
          </>
        )}

        <TableCustomerDetail
          sentOrder={sentOrder}
          tableSelected={tableSelected}
          loading={loading}
          error={error}
        />
        {sentOrder?.managementFeeStatusNormalized === ManagementFeeStatus.Processed && (
          <FooterTable onCancel={onCancelOrder} onSend={onSendOrder} />
        )}
      </VStack>
    </SliderModal>
  );
};

const styles = StyleSheet.create({
  view: {
    backgroundColor: '#F9F9F9',
  },
});
